function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4e5ca9",
  d: "M45 1h44v44H45z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4e5ca9",
  d: "M1 1h44v44H1z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fb7d74",
  d: "M45 45L1 1v44z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M1 1h44v44H1z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4e5ca9",
  d: "M89 1h44v44H89z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fca8a2",
  d: "M89 45L45 23v22z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4e5ca9",
  d: "M133 1h44v44h-44z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M177 1l-44 44h44z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fed4d1",
  d: "M133 23L89 45h44z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M133 1h44v44h-44z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M89 1h44v44H89z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M45 1h44v44H45z"
});

var SvgLegendRatioColors = function SvgLegendRatioColors(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 178 46",
    xmlSpace: "preserve"
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxNzggNDYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE3OCA0NjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiM0RTVDQTk7fQoJLnN0MXtmaWxsOiNGQjdENzQ7fQoJLnN0MntmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjI7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQoJLnN0M3tmaWxsOiNGQ0E4QTI7fQoJLnN0NHtmaWxsOiNGRkZGRkY7fQoJLnN0NXtmaWxsOiNGRUQ0RDE7fQo8L3N0eWxlPgo8ZyBpZD0iYmFjayI+CjwvZz4KPGc+Cgk8Zz4KCQk8cmVjdCB4PSI0NSIgeT0iMSIgY2xhc3M9InN0MCIgd2lkdGg9IjQ0IiBoZWlnaHQ9IjQ0Ii8+CgkJPHJlY3QgeD0iMSIgeT0iMSIgY2xhc3M9InN0MCIgd2lkdGg9IjQ0IiBoZWlnaHQ9IjQ0Ii8+CgkJPHBvbHlnb24gY2xhc3M9InN0MSIgcG9pbnRzPSI0NSw0NSAxLDEgMSw0NSAJCSIvPgoJCTxyZWN0IHg9IjEiIHk9IjEiIGNsYXNzPSJzdDIiIHdpZHRoPSI0NCIgaGVpZ2h0PSI0NCIvPgoJCTxyZWN0IHg9Ijg5IiB5PSIxIiBjbGFzcz0ic3QwIiB3aWR0aD0iNDQiIGhlaWdodD0iNDQiLz4KCQk8cG9seWdvbiBjbGFzcz0ic3QzIiBwb2ludHM9Ijg5LDQ1IDQ1LDIzIDQ1LDQ1IAkJIi8+CgkJPHJlY3QgeD0iMTMzIiB5PSIxIiBjbGFzcz0ic3QwIiB3aWR0aD0iNDQiIGhlaWdodD0iNDQiLz4KCQk8cG9seWdvbiBjbGFzcz0ic3Q0IiBwb2ludHM9IjE3NywxIDEzMyw0NSAxMzMsNDUgMTc3LDQ1IAkJIi8+CgkJPHBvbHlnb24gY2xhc3M9InN0NSIgcG9pbnRzPSIxMzMsMjMgODksNDUgODksNDUgMTMzLDQ1IAkJIi8+CgkJPHJlY3QgeD0iMTMzIiB5PSIxIiBjbGFzcz0ic3QyIiB3aWR0aD0iNDQiIGhlaWdodD0iNDQiLz4KCQk8cmVjdCB4PSI4OSIgeT0iMSIgY2xhc3M9InN0MiIgd2lkdGg9IjQ0IiBoZWlnaHQ9IjQ0Ii8+CgkJPHJlY3QgeD0iNDUiIHk9IjEiIGNsYXNzPSJzdDIiIHdpZHRoPSI0NCIgaGVpZ2h0PSI0NCIvPgoJPC9nPgo8L2c+Cjwvc3ZnPgo=";
export { SvgLegendRatioColors as ReactComponent };